var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import FileTransferApi from '~/api/file-transfer';
import GetFileUrlApi from '~/api/get-file-url';
import convertB64StringToByteArray from '~/utils/convertB64StringToByteArray';
export const getDocumentById = createAsyncThunk('document/getDocumentById', (payload_1, _a) => __awaiter(void 0, [payload_1, _a], void 0, function* (payload, { dispatch, rejectWithValue }) {
    const { id, ws } = payload;
    let result;
    try {
        const getClausesResponse = yield new Promise(resolve => {
            ws.send('request:/get-clauses:get', { routeId: id }, data => resolve(data));
        });
        if (getClausesResponse.statusCode !== 200) {
            const error = { name: 'Websocket Error', message: 'Failed to get clauses for document' };
            window.routeToErrorPage(error, JSON.stringify(getClausesResponse.payload));
        }
        else {
            result = getClausesResponse.payload;
            const fileTransferInfo = yield GetFileUrlApi.getUrlById(id);
            const jsonBlob = yield FileTransferApi.get(fileTransferInfo.fileTransferUrl);
            const text = yield jsonBlob.text();
            const byteCharacters = atob(yield JSON.parse(text).data);
            const byteArray = yield convertB64StringToByteArray(byteCharacters);
            result.blob = new Blob([byteArray], { type: 'application/pdf' });
            if (result === null || result === void 0 ? void 0 : result.clauses) {
                result.clauses.forEach(clause => {
                    clause.id = uuidv4();
                });
            }
        }
    }
    catch (err) {
        return rejectWithValue(err);
    }
    return result;
}));
